<div class="sidebar-left bg-light-grey">
  <ng-template #showLoader>
    <div class="loader-container">
      <div class="spinner-border"></div>
    </div>
    <div class="loading-content">
      <p class="loading-tip">Setting up the dashboard...<br/>You'll be redirected in a moment.</p>
    </div>  
  </ng-template>
    <div class="wrapper">
      <app-page-title
        [title]="execution?.name"
        [subtitle]="execution?.company_name"
        class="title">
      </app-page-title>
      <div class="row border-bottom pad">
        <div class="col d-inline-flex align-items-center">
          <img class="icon rounded-circle" [src]="execution?.owner?.thumbnail | authImage | async">
          <div class="d-flex flex-column">
            <p class="owner">Owner</p>
            <p class="nome">{{ execution?.owner?.name}} {{execution?.owner?.surname}}</p>
          </div>
        </div>
        <div class="col d-flex justify-content-end">
          <button class="btn btn-default" [ngClass]="{'disabled': handleDisabledButton()}" (click)='handleSubmit()'>{{btnText}}</button>
        </div>
      </div>
    </div>
    <div *ngIf='!loading; else showLoader'>
    <div class="content" *ngFor="let subTool of subTools">
      <p class="description" [innerHTML]='subTool.description'></p>
      <div class="sidebar-content mb-2" *ngFor="let subToolInfo of subTool.subtool_list">
        <i
          class="sidebar-icon"
          [class.ic-done]="subToolInfo?.subtool_available"
          [class.ic-null]="!subToolInfo?.subtool_available"
          [class.ic-failed]="!subToolInfo?.subtool_available && subToolInfo?.subtool_name === 'Configuration'">
        </i>
        <span class="sub-tool-description">{{subToolInfo?.subtool_name}}</span>
        <button
          type="button"
          class="btn info-tooltip"
          ngbTooltip="{{subToolInfo.subtool_tooltip}}"
          placement='right'
          [autoClose]="'outside'"
          triggers='hover'>
          <i class="ic-info info"></i>
        </button>
      </div>
    </div>
    <div class="description-extra-wrapper">
      <p class="description-extra" *ngIf="isDescriptionPresent">
        Click on <span class="continue">Continue</span> to confirm the configuration and view the output of your execution.
      </p>
    </div>
  </div>
</div>
